import { Link, Navigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { PublicLayout } from "../components/Common";
import { useAuth } from "../context/AuthContext";

export default function Forbidden() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/products" replace />;

  return (
    <PublicLayout>
      <div className="min-h-[60vh] grid place-items-center text-center px-4">
        <div>
          <span className="grid place-items-center h-16 w-16 rounded-2xl bg-red-50 text-red-600 mx-auto mb-5"><ShieldAlert className="h-8 w-8" /></span>
          <p className="font-heading text-6xl font-extrabold text-slate-900">403</p>
          <h1 className="font-heading text-xl font-bold text-slate-900 mt-2">Akses Ditolak</h1>
          <p className="text-slate-500 mt-1 mb-6">Anda tidak memiliki izin untuk mengakses halaman ini.</p>
          <Link to="/" className="btn-primary">Kembali ke Beranda</Link>
        </div>
      </div>
    </PublicLayout>
  );
}
